"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyBoolean = void 0;
const functions_1 = require("./functions");
const WrappedPropertyBase_1 = require("./WrappedPropertyBase");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
class WrappedPropertyBoolean extends WrappedPropertyBase_1.WrappedPropertyBase {
    constructor(props) {
        super(props);
        // initVue(this, this._internal);
    }
    /**
     * sprawdza pole pod kątem błedów
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} komunikat błędu lub null gdy błedu nie ma
     * @memberof WrappedPropertyBoolean
     */
    $validate(value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === null) {
            if (this.$schema.fieldRequired) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message,
                    expected: true
                };
                return message;
            }
            if (this.$schema.enum) {
                if (this.$schema.enum.indexOf(value) === -1) {
                    const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'enum', value, this.$schema);
                    this.$validateResult = {
                        validation: 'enum',
                        message,
                        expected: this.$schema.enum
                    };
                    return message;
                }
            }
            return null;
        }
        const ivalue = !!value;
        if (this.$schema.fieldRequired && !ivalue) {
            const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
            this.$validateResult = {
                validation: 'required',
                message,
                expected: true
            };
            return message;
        }
        return super.$validate(ivalue);
    }
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyBoolean
     */
    $check(value, skipDirty, checkResult) {
        if (this.$schema.warnings && !this.$disabled) {
            this.$checkResult = [];
            if (value === undefined) {
                value = this.$model;
            }
            if (!skipDirty) {
                this.$dirty = true;
            }
            checkResult = checkResult || [];
            if (value === null) {
                if (this.$schema.warnings.fieldRequired) {
                    const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'required',
                        message,
                        expected: true
                    });
                    checkResult.push(message);
                }
                if (this.$schema.warnings.enum) {
                    if (this.$schema.warnings.enum.indexOf(value) === -1) {
                        const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'enum', value, this.$schema);
                        this.$checkResult.push({
                            validation: 'enum',
                            message,
                            expected: this.$schema.warnings.enum
                        });
                        checkResult.push(message);
                    }
                }
                return checkResult;
            }
            const ivalue = !!value;
            if (this.$schema.fieldRequired && !ivalue) {
                const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                this.$checkResult.push({
                    validation: 'required',
                    message,
                    expected: true
                });
                checkResult.push(message);
            }
            return super.$check(ivalue, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    }
    /**
     * obranie wartości z modelu
     *
     * @protected
     * @returns
     * @memberof WrappedPropertyBoolean
     */
    getValue(svalue) {
        if (svalue === undefined)
            svalue = this.$model;
        /*
        if (this.$dirty) {
          this.$validate(svalue);
        }
        */
        // return svalue ? 'true' : 'false';
        return svalue ? 'true' : '';
    }
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyBoolean
     */
    setValue(newValue) {
        var _a, _b;
        // console.log('newValue', newValue);
        if (this.$disabled) {
            return;
        }
        this._options._userInput = true;
        if (!this.$disabled && !this.$dirty && this._internal.options.dirtyOnInput) {
            this.$dirty = true;
        }
        // debugger;
        if (newValue === null || newValue === 'null') {
            newValue = null;
        }
        else {
            newValue = newValue !== false && newValue !== 'false' && newValue !== 'off' && newValue !== '';
        }
        if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.beforeChange) {
            const prevValue = this.$model;
            if (newValue !== prevValue) {
                const event = { type: 'beforeChange', target: this, value: newValue, prevValue };
                if ((0, functions_1.runEvent)(event)) {
                    if (event.value !== newValue) {
                        newValue = event.value;
                    }
                }
            }
        }
        if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.change) {
            const prevValue = this.$model;
            this.$model = newValue;
            if (newValue != prevValue) {
                (0, functions_1.runEvent)({ type: 'change', target: this, value: newValue, prevValue });
            }
        }
        else {
            this.$model = newValue;
        }
    }
}
exports.WrappedPropertyBoolean = WrappedPropertyBoolean;
WrappedPropertyCtor_1.WrappedPropertyCtor.boolean = WrappedPropertyBoolean;
exports.default = WrappedPropertyBoolean;
//# sourceMappingURL=WrappedPropertyBoolean.js.map